import React, {useEffect} from 'react';
import {Link} from "react-router-dom";
import {staggeredFadeInDivEffect} from "./staggeredFadeInDivEffect";

import '../style/css/components/Home.css'
import {BackToTop} from "./BackToTop";

/** Fade effect
 */
// const fadeAnimation = keyframes`${fadeInLeft}`;
// const FadeDiv = styled.div`
//     animation: 0.5s ${fadeAnimation};`;

function Home(){

	useEffect(()=>{
		BackToTop()
		staggeredFadeInDivEffect(50)
	})

	return (
		<div className='fade-enter'>

			<div className="row">

				<div className="col-12 col-md-5">
					<div className="fade-enter">
						<Link to='/sobre' className="tile link">
							<h2 className='fade-enter'>
								<i className='la la-coffee'/>
								<br/>
								sobre mim
							</h2>
						</Link>
					</div>
				</div>

				<div className="col-12 col-md-7">
					<div className="fade-enter">
						<Link to='/competencias' className="tile link">
							<h2 className='fade-enter'>
								<i className='la la-certificate'/>
								<br/>
								competências
							</h2>
						</Link>
					</div>
				</div>

				<div className="col-12">
					<div className="fade-enter">
						<Link to='/contato' className="tile link">
							<h2 className='fade-enter'>
								<i className='la la-envelope'/>
								<br/>
								contato
							</h2>
						</Link>
					</div>
				</div>

			</div>

		</div>
	);
}

export default Home;
